import React from "react";
import "./Portfolio.css";
import IMG1 from "../../assests/foodhub.png";
import IMG2 from "../../assests/todoList.png";
import IMG3 from "../../assests/expenseTracker.png";
import IMG4 from "../../assests/netflix__cone.png";
import Aos from 'aos'
import 'aos/dist/aos.css'
import {useEffect} from 'react'

const data = [
  {
    id: 1,
    image: IMG1,
    title: "Food Hub",
    github: "https://github.com/danielikechukwu/foodhubapp",
    demo: "https://foodcity.netlify.app/",
  },

   {
     id: 2,
     image: IMG2,
     title: "Todo List",
     github: "https://github.com/danielikechukwu/Todo_replica",
     demo: "https://todo-replica.netlify.app/",
   },

   {
     id: 3,
     image: IMG3,
     title: "Expense tracker",
     github: "https://github.com/danielikechukwu/expense_tracking",
     demo: "https://trackingmonthlyexpense.netlify.app/",
   },

   {
     id: 4,
     image: IMG4,
     title: "Netflix clone",
     github: "https://github.com/danielikechukwu/netflix__clone",
     demo: "https://netflix-siteclone.netlify.app/",
   },

  // {
  //   id: 1,
  //   image: IMG1,
  //   title: "Food Hub",
  //   github: "https://github.com/danielikechukwu/foodhubapp",
  //   demo: "https://foodcity.netlify.app/",
  // },

  // {
  //   id: 1,
  //   image: IMG1,
  //   title: "Food Hub",
  //   github: "https://github.com/danielikechukwu/foodhubapp",
  //   demo: "https://foodcity.netlify.app/",
  // },
];

const Portfolio = () => {

  useEffect(() => {
    Aos.init({ duration: 3000 });
  }, [])


  return (
    <section id="portfolio" data-aos='fade-up'>
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio__container">
        {data.map(({ id, image, title, github, demo }) => {
          return (
            <article key={id} className="portfolio__item">
              <div className="portfolio__item-image">
                <img src={image} alt={title} className="portfolio__project" />
              </div>

              <h3>{title}</h3>

              <div className="portfolio__item-cta">
                <a href={github} className="btn" target="_blank">
                  Github
                </a>

                <a href={demo} className="btn btn-primary" target="_blank">
                  Live Demo
                </a>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
};

export default Portfolio;
